import React from "react";
import { Tooltip, Typography } from "@mui/material";

interface TruncatedCellWithTooltipProps {
  value: string;
}

const TruncatedCellWithTooltip: React.FC<TruncatedCellWithTooltipProps> = ({
  value,
}) => (
  <Tooltip title={value}>
    <Typography
      sx={{
        fontSize: "0.875rem",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        display: "block",
        width: "100%",
      }}
    >
      {value}
    </Typography>
  </Tooltip>
);

export default TruncatedCellWithTooltip;
